import { render, staticRenderFns } from "./organization-bgys-roadmap-view.vue?vue&type=template&id=2c8b36a4"
import script from "./organization-bgys-roadmap-view.vue?vue&type=script&lang=js"
export * from "./organization-bgys-roadmap-view.vue?vue&type=script&lang=js"
import style0 from "./organization-bgys-roadmap-view.vue?vue&type=style&index=0&id=2c8b36a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports